import { useState } from 'react';

export default function Hero() {
  const [showContactForm, setShowContactForm] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      await fetch('https://readdy.ai/api/form/d4hkhqser93evkarrqo0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString()
      });
      
      alert('Application sent! We will contact you shortly.');
      setShowContactForm(false);
      form.reset();
    } catch (error) {
      alert('An error occurred. Please try again.');
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/ea95e358017256b7d5c67442b80a7bc5.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.3
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/50 via-transparent to-slate-900/80 z-0" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20">
        <div className="text-left max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Systematic Marketing and <span className="text-cyan-400">Artificial Intelligence</span>: Your Key to Stable Sales Growth
          </h1>
          
          <h2 className="text-xl md:text-2xl text-gray-300 mb-10 leading-relaxed max-w-3xl">
            We turn chaos into a system. We combine expert experience with the precision of AI algorithms to scale your business.
          </h2>

          <div className="flex flex-wrap gap-4">
            <button 
              onClick={() => setShowContactForm(true)}
              className="px-8 py-4 bg-cyan-500 hover:bg-cyan-600 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg shadow-cyan-500/50 hover:shadow-cyan-500/70 whitespace-nowrap cursor-pointer"
            >
              Get Growth Strategy
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('lead-form');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-slate-900 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Discuss Project
            </button>
          </div>
        </div>
      </div>

      {/* Contact Form Modal */}
      {showContactForm && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setShowContactForm(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-6">
              <div>
                <h3 className="text-2xl font-bold text-slate-900 mb-2">Is Your Marketing Working at 100% or Draining Your Budget?</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Don't guess. Get an honest outside perspective. Sign up for a <strong className="text-cyan-600">free 20-minute express diagnostic</strong> of your project.
                </p>
              </div>
              <button onClick={() => setShowContactForm(false)} className="text-gray-500 hover:text-gray-700 cursor-pointer flex-shrink-0 ml-4">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl p-5 mb-6">
              <h4 className="font-bold text-slate-900 mb-3 text-sm">What you will learn:</h4>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-search-line text-white text-xs"></i>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Where you're losing customers right now (finding "holes" in the funnel)
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-line-chart-line text-white text-xs"></i>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    3 non-obvious growth points for scaling revenue
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-robot-line text-white text-xs"></i>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    How AI can reduce your advertising costs
                  </p>
                </div>
              </div>
            </div>

            <form className="space-y-4" data-readdy-form id="hero-contact-form-en" onSubmit={handleSubmit}>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Name <span className="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  name="name" 
                  placeholder="Your name" 
                  required 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 text-sm" 
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Phone <span className="text-red-500">*</span>
                </label>
                <input 
                  type="tel" 
                  name="phone" 
                  placeholder="+1 (999) 123-4567" 
                  required 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 text-sm" 
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Service of Interest <span className="text-red-500">*</span>
                </label>
                <select 
                  name="service" 
                  required 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 text-sm bg-white cursor-pointer"
                >
                  <option value="">Select service</option>
                  <option value="Digital Marketing 360°">Digital Marketing 360°</option>
                  <option value="Comprehensive Marketing Strategy">Comprehensive Marketing Strategy</option>
                  <option value="Marketing Consulting">Marketing Consulting</option>
                  <option value="Strategic Management and Partnership for Marketplace Manufacturers">Strategic Management and Partnership for Marketplace Manufacturers</option>
                  <option value="Marketplace Consulting">Marketplace Consulting</option>
                  <option value="Sales Website Creation">Sales Website Creation</option>
                  <option value="Contextual Advertising">Contextual Advertising</option>
                  <option value="Targeted Advertising">Targeted Advertising</option>
                  <option value="SMM and Content">SMM and Content</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Website Link <span className="text-gray-400 text-xs">(optional)</span>
                </label>
                <input 
                  type="url" 
                  name="website" 
                  placeholder="https://example.com" 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 text-sm" 
                />
              </div>
              <button type="submit" className="w-full px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
                Get Growth Strategy
              </button>
              <p className="text-xs text-gray-500 text-center">
                By clicking the button, you agree to the privacy policy
              </p>
            </form>
          </div>
        </div>
      )}

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
